"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _listeners = require("./listeners");
var _extractPlayablesFromConfig = _interopRequireDefault(require("../utils/extractPlayablesFromConfig"));
var _AdUtils = require("./AdUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Module that provides utility functions to allow adding and removing playlist items
 *
 * @module PlayablesUtils
 */

/**
 * Add a playable to the player's playables at a given index
 * Shape of playlist item: { src, (startTime, endTime, skipToTime) }
 *
 * @param {Playable}
 * @param {number}
 *
 * @return {Playable[]}
 */
function insert(playable, index) {
  var playables = this._playables;
  if (index <= playables.index && playables.index < playables.sources.length) {
    this._playables.index++;
  }
  var extractedPlayable = (0, _extractPlayablesFromConfig["default"])([playable], window.location, _AdUtils.getPlayableAds)[0];
  this._playables.sources.splice(index, 0, extractedPlayable);
  return this.playables;
}

/**
 * Push a playable into the end of the playables list.
 *
 * @param {Playable}
 *
 * @return {Playable[]}
 */
function push(playable) {
  return insert.call(this, playable, this.playables.length);
}

/**
 * Removes a playlist item from the player's playlist
 * Returns a boolean representing whether the removal was successful
 *
 * @param {number} index to remove from
 *
 * @return {Playable[]}
 */
function remove(index) {
  var playables = this._playables.sources;
  if (playables.length <= 1) {
    throw new Error('VideoPlayback: You cannot remove all playables.');
  }
  playables.splice(index, 1);
  if (index === this.playingIndex) {
    var wasPaused = this.paused;

    // tries to play the next playable after this one
    // or goes to the first playable
    var playable = playables[index];
    if (!playable) {
      playable = playables[0];
      this._playables.index = 0;
    }
    this.src = playable.src;
    this.currentTime = 0;
    wasPaused ? this.pause() : this.play();
  } else if (index < this.playingIndex) {
    this._playables.index--;
  }
  _listeners.onPlaylistItem.call(this, {
    index: this._playables.index
  });
  return this.playables;
}
var _default = exports["default"] = {
  insert: insert,
  push: push,
  remove: remove
};